import aiInventory from './aiInventory'
import aiInventoryPurposes from './aiInventoryPurposes'
import aiInventoryRiskOptions from './aiInventoryRiskOptions'
import aiInventoryTools from './aiInventoryTools'
import answerOptionTickets from './answerOptionTickets'
import assetInventory from './assetInventory'
import assetInventoryCategory from './assetInventoryCategory'
import auditConfigs from './auditConfigs'
import auditProcesses from './auditProcesses'
import auth from './auth'
import changesManagement from './changesManagement'
import committeeCategories from './committeeCategories'
import committeeRoles from './committeeRoles'
import committees from './committees'
import committeeUsers from './committeeUsers'
import communicationIncidentEmail from './communicationIncidentEmail'
import companies from './companies'
import companyAudits from './companyAudits'
import companyFavorites from './companyFavorites'
import companyGuestEmails from './companyGuestEmails'
import companyGuestDomains from './companyGuestDomains'
import companyGuestPortalConfig from './companyGuestPortalConfig'
import companyDocuments from './companyDocuments'
import companyFragilities from './companyFragilities'
import companyFreeTrials from './companyFreeTrials'
import companySizes from './companySizes'
import companyTrails from './companyTrails'
import complaint from './complaint'
import complaintCategories from './complaintCategories'
import complaintConfigurations from './complaintConfigurations'
import complaintMessage from './complaintMessage'
import complaintSubCategories from './complaintSubCategories'
import complaintTwoFactorStorage from './complaintTwoFactorStorage'
import consent from './consent'
import cookieConsentCompanies from './cookieConsentCompanies'
import cookieConsents from './cookieConsents'
import cookieTags from './cookieTags'
import coupons from './coupons'
import daiChatMessages from './daiChatMessages'
import daiChats from './daiChats'
import daiFeedbacks from './daiFeedbacks'
import daiOptOuts from './daiOptOuts'
import dataCollectedOptions from './dataCollectedOptions'
import dataCollecteds from './dataCollecteds'
import dataIntelligence from './dataIntelligence'
import dataLifeCycles from './dataLifeCycles'
import dataProcesses from './dataProcesses'
import dataProcessTags from './dataProcessTags'
import dataProcessTemplates from './dataProcessTemplates'
import dataProcessTreatment from './dataProcessTreatment'
import dataTreatmentAgents from './dataTreatmentAgents'
import dataTreatments from './dataTreatments'
import departments from './departments'
import externalPlatformIntegrations from './externalPlatformIntegrations'
import documentCategories from './documentCategories'
import documents from './documents'
import documentTemplates from './documentTemplates'
import documentTemplateVariables from './documentTemplateVariables'
import documentVersions from './documentVersions'
import externalServices from './externalServices'
import faqsDocumentations from './faqsDocumentations'
import faqsDocumentationsCategories from './faqsDocumentationsCategories'
import financialPanel from './financialPanel'
import governanceProject from './governanceProject'
import governanceProjectActivity from './governanceProjectActivity'
import governanceProjectQuestionnaire from './governanceProjectQuestionnaire'
import governanceProjectStage from './governanceProjectStage'
import governanceProjectTemplate from './governanceProjectTemplate'
import incidentRiskAssumptions from './incidentRiskAssumptions'
import incidents from './incidents'
import internationalTransfer from './internationalTransfers'
import juridicTickets from './juridicTickets'
import kanbanBoards from './kanbanBoards'
import kanbanColumns from './kanbanColumns'
import kanbanConfigurations from './kanbanConfigurations'
import kanbanTasks from './kanbanTasks'
import lastUpdates from './lastUpdate'
import legalFrameworks from './legalFrameworks'
import liaAnswers from './liaAnswers'
import liaQuestions from './liaQuestions'
import matrixRisk from './matrixRisk'
import monitoringManagementKpi from './monitoringManagementKpi'
import monitoringManagementKpiMetrics from './monitoringManagementKpiMetrics'
import monitoringManagementNc from './monitoringManagementNc'
import monitoringManagementNcActions from './monitoringManagementNcActions'
import monitoringManagementPmc from './monitoringManagementPmc'
import moodleLotus from './moodleLotus'
import myLgpd from './myLgpd'
import necessityProportionality from './necessityProportionality'
import nonComplianceReportActions from './nonComplianceReportActions'
import nonComplianceReports from './nonComplianceReports'
import observerInvite from './observerInvite'
import oldDocumentTemplates from './oldDocumentTemplates'
import organizations from './organizations'
import outsourcedDpo from './outsourcedDpo'
import paymentContracts from './paymentContracts'
import phishingCampaigns from './phishingCampaigns'
import phishingIndicators from './phishingIndicators'
import phishingTemplates from './phishingTemplates'
import paymentLink from './paymentLink'
import paymentOrders from './paymentOrders'
import payments from './payments'
import pdca from './pdca'
import plans from './plans'
import preRegistrations from './preRegistrations'
import privacyByDesign from './privacyByDesign'
import privacyPolicies from './privacyPolicies'
import privacyPortal from './privacyPortal'
import privacyStamps from './privacyStamps'
import profiles from './profiles'
import promotionalBanners from './promotionalBanners'
import publicModules from './public'
import questionControls from './questionControls'
import questionnaires from './questionnaires'
import quizQuestionTemplates from './quizQuestionTemplates'
import quizTemplates from './quizTemplates'
import rdStation from './rdStation'
import regulationVersions from './regulationVersions'
import reports from './reports'
import reportVersions from './reportVersions'
import residualRisks from './residualRisks'
import resume from './resume'
import ripds from './ripds'
import securityMeasureCategories from './securityMeasureCategories'
import securityMeasures from './securityMeasures'
import segments from './segments'
import sharedCollectedFields from './sharedCollectedFields'
import sharedSoftwares from './sharedSoftwares'
import smtp from './smtp'
import specificRisks from './specificRisks'
import ssoCorporateGroups from './ssoCorporateGroups'
import suggestedChanges from './suggestedChanges'
import suggestedSuppliers from './suggestedSuppliers'
import supplierInvite from './supplierInvite'
import supplierQuestionnaires from './supplierQuestionnaires'
import supplierQuizTemplates from './supplierQuizTemplates'
import suppliers from './suppliers'
import tags from './tags'
import activityComments from './activityComments'
import technicalFaqs from './technicalFaqs'
import tickets from './tickets'
import titularTickets from './titularTickets'
import tomticketIntermediator from './tomticketIntermediator'
import trainingCourse from './trainingCourse'
import trainingEnrollment from './trainingEnrollment'
import trainningJourneys from './trainningJourneys'
import twoFactorAuthentication from './twoFactorAuthentication'
import users from './users'
import usersCompanies from './usersCompanies'
import whiteLabel from './whiteLabel'

export default {
  aiInventory,
  aiInventoryPurposes,
  aiInventoryRiskOptions,
  aiInventoryTools,
  answerOptionTickets,
  assetInventory,
  assetInventoryCategory,
  auditConfigs,
  auditProcesses,
  auth,
  changesManagement,
  committeeCategories,
  committeeRoles,
  committees,
  committeeUsers,
  communicationIncidentEmail,
  companies,
  companyAudits,
  companyFavorites,
  companyGuestEmails,
  companyGuestDomains,
  companyGuestPortalConfig,
  companyDocuments,
  companyFragilities,
  companyFreeTrials,
  companySizes,
  companyTrails,
  complaint,
  complaintCategories,
  complaintConfigurations,
  complaintMessage,
  complaintSubCategories,
  complaintTwoFactorStorage,
  consent,
  cookieConsentCompanies,
  cookieConsents,
  cookieTags,
  coupons,
  daiChatMessages,
  daiChats,
  daiFeedbacks,
  daiOptOuts,
  dataCollectedOptions,
  dataCollecteds,
  dataIntelligence,
  dataLifeCycles,
  dataProcesses,
  dataProcessTags,
  dataProcessTemplates,
  dataProcessTreatment,
  dataTreatmentAgents,
  dataTreatments,
  departments,
  externalPlatformIntegrations,
  documentCategories,
  documents,
  documentTemplates,
  documentTemplateVariables,
  documentVersions,
  externalServices,
  faqsDocumentations,
  faqsDocumentationsCategories,
  financialPanel,
  governanceProject,
  governanceProjectActivity,
  governanceProjectQuestionnaire,
  governanceProjectStage,
  governanceProjectTemplate,
  incidentRiskAssumptions,
  incidents,
  internationalTransfer,
  juridicTickets,
  kanbanBoards,
  kanbanColumns,
  kanbanConfigurations,
  kanbanTasks,
  lastUpdates,
  legalFrameworks,
  liaAnswers,
  liaQuestions,
  matrixRisk,
  monitoringManagementKpi,
  monitoringManagementKpiMetrics,
  monitoringManagementNc,
  monitoringManagementNcActions,
  monitoringManagementPmc,
  moodleLotus,
  myLgpd,
  necessityProportionality,
  nonComplianceReportActions,
  nonComplianceReports,
  observerInvite,
  oldDocumentTemplates,
  organizations,
  outsourcedDpo,
  paymentContracts,
  paymentLink,
  phishingCampaigns,
  phishingIndicators,
  phishingTemplates,
  paymentOrders,
  payments,
  pdca,
  plans,
  preRegistrations,
  privacyByDesign,
  privacyPolicies,
  privacyPortal,
  privacyStamps,
  profiles,
  promotionalBanners,
  public: publicModules,
  questionControls,
  questionnaires,
  quizQuestionTemplates,
  quizTemplates,
  rdStation,
  regulationVersions,
  reports,
  reportVersions,
  residualRisks,
  resume,
  ripds,
  securityMeasureCategories,
  securityMeasures,
  segments,
  sharedCollectedFields,
  sharedSoftwares,
  smtp,
  specificRisks,
  ssoCorporateGroups,
  suggestedChanges,
  suggestedSuppliers,
  supplierInvite,
  supplierQuestionnaires,
  supplierQuizTemplates,
  suppliers,
  tags,
  activityComments,
  technicalFaqs,
  tickets,
  titularTickets,
  tomticketIntermediator,
  trainingCourse,
  trainingEnrollment,
  trainningJourneys,
  twoFactorAuthentication,
  users,
  usersCompanies,
  whiteLabel,
}
